import(/* webpackMode: "eager" */ "/app/apps/admin-web/src/app/global-error.tsx");
